const baseUrl = "https://api.xinshuangpai.com"
export default baseUrl

/**
 * cors
 * proxy:开发环境
 */